import { useState } from 'react';

// Open/close state for the homepage's three modals, plus the handlers sections call.
export const useHomeModals = () => {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [guideOpen, setGuideOpen] = useState(false);
  const [guideType, setGuideType] = useState('buyer');
  const [relocationOpen, setRelocationOpen] = useState(false);
  const [relocationArea, setRelocationArea] = useState('both');

  const openPrivacyPolicy = () => setPrivacyOpen(true);
  const openGuideModal = (type) => { setGuideType(type); setGuideOpen(true); };
  const openRelocationGuide = (area) => { setRelocationArea(area); setRelocationOpen(true); };

  return {
    openPrivacyPolicy,
    openGuideModal,
    openRelocationGuide,
    privacy: { open: privacyOpen, onClose: () => setPrivacyOpen(false) },
    guide: { open: guideOpen, onClose: () => setGuideOpen(false), guideType, setGuideType },
    relocation: { open: relocationOpen, onClose: () => setRelocationOpen(false), initialArea: relocationArea },
  };
};
